"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrumMyTasksRepository = exports.scrumTasksRepository = exports.scrumContractsWithChildrenRepository = exports.scrumContractsListRepository = void 0;
const RepositoryReact_1 = __importDefault(require("../React/RepositoryReact"));
/**
 * Repozytoria dla Scrumboarda. Osobne instancje (nazwy z sufiksem "Scrumboard"),
 * aby nie kolidować z globalnymi repozytoriami TasksGlobal.
 */
/** Płaska lista kontraktów ENVI (lewy panel) */
exports.scrumContractsListRepository = new RepositoryReact_1.default({
    actionRoutes: {
        getRoute: "contracts",
        addNewRoute: "contractReact",
        editRoute: "contract",
        deleteRoute: "contract",
    },
    name: "scrumboardContractsList",
});
/** Drzewo kontraktu (prawy panel / moje zadania) */
exports.scrumContractsWithChildrenRepository = new RepositoryReact_1.default({
    actionRoutes: {
        getRoute: "contractsWithChildren",
        addNewRoute: "",
        editRoute: "",
        deleteRoute: "",
    },
    name: "scrumboardContractsWithChildren",
});
/** Zadania w drzewie "Aktualny Sprint" (leaves). Osobne repo od "Moje zadania",
 *  aby kliknięcia wierszy nie myliły się między panelami (repository.items = źródło prawdy). */
exports.scrumTasksRepository = new RepositoryReact_1.default({
    actionRoutes: {
        getRoute: "tasks",
        addNewRoute: "task",
        editRoute: "task",
        deleteRoute: "task",
    },
    name: "scrumboardTasks",
});
/** Zadania w drzewie "Moje zadania" (osobne repo). */
exports.scrumMyTasksRepository = new RepositoryReact_1.default({
    actionRoutes: {
        getRoute: "tasks",
        addNewRoute: "task",
        editRoute: "task",
        deleteRoute: "task",
    },
    name: "scrumboardMyTasks",
});
